import React from 'react';
import { ElevatedButton } from '@producer/ui-kit';

import styles from './page-placeholder.module.scss';
type PagePlaceholderBasicProps = {
  description?: string;
  backgroundImgUrl?: string;
  title?: string;
  src?: string;
  fullWidth?: boolean;
};

type NoActionPlaceholderProps = PagePlaceholderBasicProps & {
  actionButton?: never;
  actions?: never;
};

type SingleActionPlaceholderProps = PagePlaceholderBasicProps & {
  actions?: never;
  actionButton: {
    text: string;
    onClick?: React.ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
  };
};

type MultiActionPlaceholderProps = PagePlaceholderBasicProps & {
  actions: React.ReactNode[];
  actionButton?: never;
};

type PagePlaceholderProps =
  | NoActionPlaceholderProps
  | SingleActionPlaceholderProps
  | MultiActionPlaceholderProps;

export const PagePlaceholder: React.FC<PagePlaceholderProps> = ({
  backgroundImgUrl = '/images/default-background.svg',
  title,
  description,
  actionButton,
  actions,
  fullWidth,
}) => {
  const { text, onClick = () => {} } = actionButton || {};

  return (
    <div className={styles['container']}>
      <div
        className={styles['logo-background']}
        style={
          backgroundImgUrl
            ? ({ backgroundImage: `url(${backgroundImgUrl})` } as React.CSSProperties)
            : undefined
        }
      >
        <div className={styles['wrapper-box']} data-full-width={fullWidth}>
          {title && <p className={styles['description']}>{title}</p>}

          <p className={styles['description']}>{description}</p>

          {actionButton && <ElevatedButton onClick={onClick} text={text!} />}

          {!!actions?.length && (
            <div className={styles['action-container']}>{actions.map((action) => action)}</div>
          )}
        </div>
      </div>
    </div>
  );
};
